import classNames from 'classnames'
import React from 'react'
import trans from '~/translations/trans'

type ModalWrapperProps = {
  children: React.ReactNode
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({ children }) => (
  <div className="modal is-active">
    <div className="modal-background"></div>
    {children}
  </div>
)

type ModalHeaderProps = {
  title: string
  onClose: () => void
}

//

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => (
  <header className="modal-card-head">
    <p className="modal-card-title">{title}</p>
    <button className="delete" aria-label="close" onClick={onClose}></button>
  </header>
)

//

type ModalBody = {
  children: React.ReactNode
}

export const ModalBody: React.FC<ModalBody> = ({ children }) => (
  <section className="modal-card-body">{children}</section>
)

//

type ModalFooterInForm = {
  onCancel: () => void
  isSubmitting: boolean
}

export const ModalFooterInForm: React.FC<ModalFooterInForm> = ({
  isSubmitting,
  onCancel,
}) => (
  <footer className="modal-card-foot">
    <button
      className={classNames('button is-primary', {
        'is-loading': isSubmitting,
      })}
      type="submit"
    >
      {trans.form.send()}
    </button>

    <button className="button" type="button" onClick={onCancel}>
      {trans.form.cancel()}
    </button>
  </footer>
)
